
import { useState } from 'react';
import PortfolioModal from './PortfolioModal';

export default function PortfolioGrid() {
  const [selectedCase, setSelectedCase] = useState<number | null>(null);

  const cases = [
    {
      id: 1,
      title: '台南｜40年老屋全室改造',
      location: '台南市',
      area: '35坪',
      tags: ['舊屋改造', '全室翻新', '格局優化'],
      beforeImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/4d56bcea03e64b9bc9b25bcc011c73a2.jpeg',
      afterImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/6b0a39c44877f3460af9aa1c419cd0ac.jpeg',
      description: '屋主希望改造原有空間老舊與使用不便的問題，透過規劃與施工重新配置，讓空間兼具美感與實用性，打造更加舒適的居住環境。',
      beforeConditions: [
        '40年屋齡老屋，整體翻新',
        '空間採光不足',
        '收納與動線不佳',
        '浴室防水老化',
        '整體風格過時',
      ],
      renovationPoints: [
        '整體格局打除並重新配置',
        '水電線路全面更新',
        '防水工程重新施作',
        '磁磚與建材更新',
        '照明與收納優化',
        '軟裝完成整體風格',
      ],
      highlights: [
        '空間更明亮',
        '動線更流暢',
        '收納提升',
        '風格一致',
        '居住品質提升',
      ],
      testimonial: '整個空間變得非常舒適，施工過程也很安心。',
      client: '陳小姐',
    },
    {
      id: 2,
      title: '高雄｜小坪數浴室改造',
      location: '高雄市',
      area: '2坪',
      tags: ['浴室改造', '防水工程', '設備更新'],
      beforeImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/4dfdf2f57f47b75c3fc5db0700ad28a5.jpeg',
      afterImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/4496d8f0e50fd3cbf30944f0f1d66882.jpeg',
      description: '屋主希望改造原有浴室老舊樣貌與漏水問題，更新完整的防水工程與設計款磁磚搭配，讓浴室煥然一新，提升舒適使用度。',
      beforeConditions: [
        '浴室老舊漏水嚴重',
        '磁磚樣式不美觀',
        '設備老舊故障',
        '窗戶老舊',
        '使用動線不佳',
      ],
      renovationPoints: [
        '舊浴室完整打除',
        '防水層重新施作',
        '磁磚更新',
        '衛浴設備全面換新',
        '氣密窗改善',
        '設備位移動線更便利',
      ],
      highlights: [
        '徹底解決漏水',
        '空間更舒適',
        '設備現代化',
        '清潔更容易',
        '使用更安心',
      ],
      testimonial: '浴室改造的效果超乎預期，現在變得像飯店一樣舒適。',
      client: '林先生',
    },
    {
      id: 3,
      title: '台南｜軟裝設計改造',
      location: '台南市',
      area: '20坪',
      tags: ['浴室設計', '防水工程', '設備更新'],
      beforeImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/387306cc4eebc4a1cce01144b08ed368.jpeg',
      afterImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/8edc3e287b1d836af78276d8f0e6570d.jpeg',
      description: '屋主希望在裝修完成後能直接入住，透過完整的軟裝設計規劃搭配服務，從家具到擺設，打造溫馨舒適的居家空間。',
      beforeConditions: [
        '空屋無家具配置',
        '缺乏整體風格',
        '照明氛圍不足',
        '空間感覺空蕩',
        '無法直接入住',
      ],
      renovationPoints: [
        '家具選購與配置',
        '燈具照明設計',
        '窗簾布藝搭配',
        '裝飾品與綠植',
        '色彩風格規劃',
        '整體氛圍營造',
      ],
      highlights: [
        '風格統一協調',
        '空間溫馨舒適',
        '功能完整實用',
        '可直接入住',
        '生活品質提升',
      ],
      testimonial: '軟裝搭配得很好，省去很多採購的煩惱，裝修後就能直接入住。',
      client: '張小姐',
    },
    {
      id: 4,
      title: '高雄｜老屋廚房翻新',
      location: '高雄市',
      area: '6坪',
      tags: ['廚房改造', '設備更新', '收納優化'],
      beforeImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/e744b6cc21967f02e5bac667caacaf9b.jpeg',
      afterImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/738d17ee72e2c3b2e6aa799710c1322d.jpeg',
      description: '屋主希望將老舊廚房改造打造現代化的烹飪空間，打造明亮整潔且功能完善的廚房環境。',
      beforeConditions: [
        '廚具老舊油污嚴重',
        '收納空間不足',
        '檯面材質不滿意',
        '排油煙效果差',
        '地壁磁磚老舊',
      ],
      renovationPoints: [
        '廚具全面更新',
        '檯面重新配置',
        '收納櫃體增設',
        '排油煙機更換',
        '照明系統升級',
        '磁磚牆面翻新',
      ],
      highlights: [
        '烹飪更便利',
        '收納大幅提升',
        '清潔更容易',
        '空間更明亮',
        '使用更安全',
      ],
      testimonial: '新廚房讓我愛上下廚，收納空間變多了，整理起來也輕鬆很多。',
      client: '王太太',
    },
    {
      id: 5,
      title: '高雄｜浴室擴大翻新',
      location: '高雄市',
      area: '8坪',
      tags: ['浴室設計', '格局修改', '設備更新'],
      beforeImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/ee02172393b4b02fffa6cec800795d50.jpeg',
      afterImage: 'https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/b437e4a067b4f6f7ff42606faa97bbb3.jpeg',
      description: '屋主希望將原有雜物間改為浴室配置，擁有飯店級大空間，讓生活更享受更舒適!!',
      beforeConditions: [
        '舊有浴室空間狹小',
        '設備故障需更換',
        '風格老舊不美觀',
        '使用感受不佳',
        '整體缺乏儀式感',
      ],
      renovationPoints: [
        '浴室設計規劃',
        '隔間空間打除擴大',
        '衛浴設備更新',
        '乾溼分離淋浴間',
        '照明氛圍營造',
        '收納機能規劃',
      ],
      highlights: [
        '整體質感升級',
        '空間感大幅提升',
        '乾濕分離更舒適',
        '收納機能完整',
        '空間更寬敞明亮',
      ],
      testimonial: '改造後很快就租出去了，租金也比之前高，非常值得的投資。',
      client: '黃先生',
    },
  ];

  return (
    <>
      <section className="py-24 bg-warm-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cases.map((caseItem) => (
              <div
                key={caseItem.id}
                onClick={() => setSelectedCase(caseItem.id)}
                className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              >
                <div className="relative h-80">
                  <div className="absolute inset-0 grid grid-cols-2 gap-px">
                    <div className="relative overflow-hidden">
                      <div className="absolute top-3 left-3 z-10 px-3 py-1 bg-black/60 text-white text-xs font-medium rounded-full backdrop-blur-sm">
                        改造前
                      </div>
                      <img
                        src={caseItem.beforeImage}
                        alt={`${caseItem.title} - 改造前`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="relative overflow-hidden">
                      <div className="absolute top-3 right-3 z-10 px-3 py-1 bg-accent text-white text-xs font-medium rounded-full">
                        改造後
                      </div>
                      <img
                        src={caseItem.afterImage}
                        alt={`${caseItem.title} - 改造後`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  </div>
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{caseItem.title}</h3>
                  <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                    <span className="flex items-center gap-1">
                      <i className="ri-map-pin-line text-accent"></i>
                      {caseItem.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-ruler-line text-accent"></i>
                      {caseItem.area}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {caseItem.tags.map((tag, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-warm-100 text-primary text-xs font-medium rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-accent font-medium">查看完整案例</span>
                    <i className="ri-arrow-right-line text-accent group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedCase && (
        <PortfolioModal
          caseData={cases.find((c) => c.id === selectedCase)!}
          onClose={() => setSelectedCase(null)}
        />
      )}
    </>
  );
}
